import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-12 col-xl-12 col-lg-12 pe-xxl-12 mb-md-25" }
const _hoisted_3 = { class: "row gx-xxl-6" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "form-group mb-25" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group mb-25" }
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = { class: "form-group mb-25" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = { class: "form-group mb-25" }
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = { class: "form-group mb-25" }
const _hoisted_15 = { class: "col-lg-6" }
const _hoisted_16 = { class: "form-group mb-25" }
const _hoisted_17 = { class: "col-lg-6" }
const _hoisted_18 = { class: "form-group mb-25" }
const _hoisted_19 = { class: "col-lg-6" }
const _hoisted_20 = { class: "form-group mb-25" }
const _hoisted_21 = { class: "col-lg-6" }
const _hoisted_22 = { class: "form-group mb-25" }
const _hoisted_23 = { class: "col-lg-12" }
const _hoisted_24 = { class: "form-group mb-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    action: "#",
    class: "pb-60",
    onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitProduct && _ctx.submitProduct(...args)), ["prevent"]))
  }, [
    (_ctx.alertMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`alert alert-${_ctx.alertType} alert-dismissible fade show`),
          role: "alert"
        }, [
          _createTextVNode(_toDisplayString(_ctx.alertMessage) + " ", 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeAlert && _ctx.closeAlert(...args))),
            "aria-label": "Close"
          })
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Product Name", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productName) = $event)),
                type: "text",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: "Enter Product Name",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.productName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Product Number (Barcode)", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.productNumber) = $event)),
                type: "text",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: "Scan Code",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.productNumber]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Category", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCategory) = $event)),
                class: "bg-white border-0 rounded-1 fs-14 text-optional"
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("option", { value: "0" }, "Choose Category", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: category.name,
                    value: category.name
                  }, _toDisplayString(category.name), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedCategory]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Product Price", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.productPrice) = $event)),
                type: "number",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: "Enter Product Price",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.productPrice]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Product Quantity", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productQuantity) = $event)),
                type: "number",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: "01",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.productQuantity]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Stock Alert (Reorder Quantity)", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.minimumReorderQuantity) = $event)),
                type: "number",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: "0",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.minimumReorderQuantity]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Expiry Date", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.expiryDate) = $event)),
                type: "date",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.expiryDate]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Is Return Accepted", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isReturnAccepted) = $event)),
                class: "bg-white border-0 rounded-1 fs-14 text-optional",
                required: ""
              }, _cache[20] || (_cache[20] = [
                _createElementVNode("option", { value: true }, "Yes", -1),
                _createElementVNode("option", { value: false }, "No", -1)
              ]), 512), [
                [_vModelSelect, _ctx.isReturnAccepted]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Return Time Accepted (Hours)", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.returnTimeAccepted) = $event)),
                type: "number",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: "Enter Return Time in Hours",
                min: "0",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.returnTimeAccepted]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Notes", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.productDescription) = $event)),
                cols: "30",
                rows: "10",
                placeholder: "Add a note",
                class: "d-block w-100 bg-white border-0 rounded-1 resize-none fs-14 text-title"
              }, null, 512), [
                [_vModelText, _ctx.productDescription]
              ])
            ])
          ]),
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-12" }, [
            _createElementVNode("button", {
              class: "btn style-one transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16",
              type: "submit"
            }, " Submit Product ")
          ], -1))
        ])
      ])
    ])
  ], 32))
}